@if (betslip.bets.length > 0) {
    @if (bet.needToShowEventView && bet.event) {
        <ms-my-bets-betslip-event-info
            [betslip]="betslip"
            [bet]="bet"
            [event]="bet.event"
            [myBetsListContext]="myBetsListContext"
            [shouldApplyPaddings]="true"
            [cancelledBet]="cancelledBet()"
            [cashedOut]="cashedOut()">
            <ms-my-bets-betslip-card-title-options
                topright-section
                [betslip]="betslip"
                [myBetsListContext]="myBetsListContext"
                [isBetSlipBadgeVisible]="true" />

            <ng-container mybets-event-info-betslip-headsection [ngTemplateOutlet]="headSection" />
        </ms-my-bets-betslip-event-info>
    } @else {
        <ms-my-bets-betslip-non-event-info
            [betslip]="betslip"
            [bet]="bet"
            [event]="bet.event"
            [myBetsListContext]="myBetsListContext"
            [shouldApplyPaddings]="true"
            [cancelledBet]="cancelledBet()"
            [cashedOut]="cashedOut()">
            <ms-my-bets-betslip-card-title-options
                topright-section
                [betslip]="betslip"
                [myBetsListContext]="myBetsListContext"
                [isBetSlipBadgeVisible]="true" />

            <ng-container mybets-non-event-info-betslip-headsection [ngTemplateOutlet]="headSection" />
        </ms-my-bets-betslip-non-event-info>
    }

    @if (isCashoutMessageVisible) {
        <ms-edit-bet-cashout-message />
    }
}

<ng-template #headSection>
    <ms-my-bets-bet-card-title
        [betslip]="betslip"
        [bet]="bet"
        [myBetsListContext]="myBetsListContext"
        [showEditButton]="true"
        [showOutcomeBadge]="true"
        [shouldApplyPaddings]="true">
        <ms-my-bets-betslip-option-name title [bet]="bet" />
        <ms-my-bets-betslip-market-name sub_title [bet]="bet" [betslip]="betslip" [cashedOut]="cashedOut()" [cancelledBet]="cancelledBet()" />
    </ms-my-bets-bet-card-title>
</ng-template>
